export default {
  name: "serviceItem",
  props: {
    service: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    goToDetails() {
      this.$router.push("/service/" + this.service._id)
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/MarketBoard/ServiceItem/ServiceItem.component.js